import ZoomableImage, { IZoomableImageProps } from './ZoomableImage';

export { IZoomableImageProps };
export default ZoomableImage;
